var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',{attrs:{"size":_vm.size,"disabled":_vm.disabled},on:{"change":_vm.change},model:{value:(_vm.selections),callback:function ($$v) {_vm.selections=$$v},expression:"selections"}},_vm._l((_vm.enums),function(item){return _c('el-radio',{key:item.id,attrs:{"label":item.value}},[_vm._v(_vm._s(item.name))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5890c700","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/view/Enum/cmps/radio/src/radio.vue
// module id = null
// module chunks = 